class MainNav {
    init($nav) {
        this.state = {
            isScrolled: false,
            mouseOver: false,
            scrollTimer: null
        };


        this.$nav = $nav;

        this.activeClass = 'c-header--white';

        this.handleFocusState();

        window.addEventListener('scroll', () => {
            this.handleScroll();
        }, false);
    }

    handleScroll() {

        if (this.state.scrollTimer) {
            clearTimeout(this.state.scrollTimer);
        }

        this.state.scrollTimer = setTimeout(() => {

            let scrollY = window.scrollY || window.pageYOffset;

            if (scrollY > 0 && !this.state.isScrolled) {
                this.state.isScrolled = true;

                if (this.$nav.classList.contains('c-header--home')) {
                    this.$nav.classList.add(this.activeClass);
                }
            }
            else if (scrollY <= 0) {
                this.state.isScrolled = false;

                if (!this.state.mouseOver && document.querySelector('.js-header-visual') !== null) {
                    this.$nav.classList.remove(this.activeClass);
                }
            }

        }, 15);
    }


    handleFocusState() {

        this.$nav.addEventListener('mouseenter', e => {

            this.state.mouseOver = true;

            if (this.state.isScrolled)
                return;

            if (this.$nav.classList.contains('c-header--home')) {
                this.$nav.classList.add(this.activeClass);
            }
        });

        this.$nav.addEventListener('mouseleave', e => {

            this.state.mouseOver = false;

            if (this.state.isScrolled)
                return;

            if (document.querySelector('.js-header-visual') !== null)
                this.$nav.classList.remove(this.activeClass);
        });

    }

}

[...document.querySelectorAll('.js--header')].forEach($el => {
    const inst = new MainNav();
    inst.init($el);
});
